//rfce
import {
  Avatar,
  Backdrop,
  Button,
  createMuiTheme,
  Fade,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  makeStyles,
  Modal,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import EditIcon from "@material-ui/icons/Edit";
import "./Todo.css";
import DeleteIcon from "@material-ui/icons/Delete";
import db from "./firebase";

import { red, pink, yellow, green, blue } from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "auto",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid pink",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  red: {
    color: theme.palette.getContrastText(red[500]),
    backgroundColor: red[500],
  },
  yellow: {
    color: theme.palette.getContrastText(yellow[500]),
    backgroundColor: yellow[500],
  },
  green: {
    color: theme.palette.getContrastText(green[500]),
    backgroundColor: green[500],
  },
  blue: {
    color: theme.palette.getContrastText(blue[500]),
    backgroundColor: blue[500],
  },
  pink: {
    color: theme.palette.getContrastText(pink[500]),
    backgroundColor: pink[500],
  },
  form_control: {
    margin: 10,
  },
  grid: {
    height: "auto",
    width: 150,
    padding: theme.spacing(2),
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
  },
}));

function Todo(props) {
  const [open, setOpen] = useState(false);
  const [spacing, setSpacing] = useState(3);
  const classes = useStyles();
  const updateTodo = (event) => {
    event.preventDefault(); //This stops the refresh
    if (input == " " || ini == " " || input == "" || ini == "") {
      alert("You haven't filled out all the fields!");
    } else {
      db.collection("todos").doc(props.todo.id).set(
        {
          todo: input,
          name: ini,
          priority: priority,
        },
        { merge: true }
      );
    }
    setOpen(false);
  };

  const giant = props.todo.name;
  const [input, setInput] = useState(props.todo.todo);
  const [ini, setIni] = useState(props.todo.name);
  const [priority, setPriority] = useState(props.todo.priority);

  return (
    <Grid item>
      <Grid container justify="center" spacing={spacing}>
        <Grid item>
          <Paper className={classes.grid}>
            <Grid item>
              <Avatar
                alt={giant}
                src="static/images/avatar/1.jpg"
                className={eval("classes." + props.todo.priority)}
              ></Avatar>
            </Grid>
            <Grid item>
              <Typography variant="h6">{props.todo.todo}</Typography>
              <p>{props.todo.name}</p>
            </Grid>
            <Grid item>
              {" "}
              <IconButton
                color="secondary"
                onClick={(event) =>
                  db.collection("todos").doc(props.todo.id).delete()
                }
                aria-label="delete"
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                color="primary"
                onClick={(e) => setOpen(true)}
                aria-label="edit"
              >
                <EditIcon />
              </IconButton>
              <Modal
                className={classes.modal}
                open={open}
                onClose={(e) => setOpen(false)}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={open}>
                  <div className={classes.paper}>
                    <h2 id="transition-modal-title">Edit</h2>
                    <form action="">
                      <FormControl className={classes.form_control}>
                        <TextField
                          id="outlined-required"
                          label="To do"
                          defaultValue={props.todo.todo}
                          // value={input}
                          onChange={(event) => setInput(event.target.value)}
                          variant="outlined"
                        />
                      </FormControl>

                      <FormControl className={classes.form_control}>
                        <TextField
                          id="outlined-required"
                          label="Name"
                          defaultValue={props.todo.name}
                          // value={input}
                          onChange={(event) => setIni(event.target.value)}
                          variant="outlined"
                        />
                      </FormControl>
                      <FormControl className={classes.form_control}>
                        <FormLabel component="legend">Priority Level</FormLabel>
                        <RadioGroup
                          row
                          defaultValue={props.todo.priority}
                          onChange={(event) => setPriority(event.target.value)}
                        >
                          <FormControlLabel
                            value="green"
                            control={<Radio />}
                            label="No"
                          />
                          <FormControlLabel
                            value="yellow"
                            control={<Radio />}
                            label="Low"
                          />
                          <FormControlLabel
                            value="blue"
                            control={<Radio />}
                            label="Medium"
                          />
                          <FormControlLabel
                            value="pink"
                            color={classes.red}
                            control={<Radio />}
                            label="High"
                          />
                          <FormControlLabel
                            color="red"
                            value="red"
                            control={<Radio />}
                            label="Urgent!!!"
                          />
                        </RadioGroup>
                      </FormControl>
                      <FormControl className="form_control">
                        <div>
                          <Button
                            color="secondary"
                            // disab
                            type="submit"
                            onClick={updateTodo}
                          >
                            Update
                          </Button>
                        </div>
                      </FormControl>
                    </form>
                    <Button color="primary" onClick={(e) => setOpen(false)}>
                      Cancel
                    </Button>
                  </div>
                </Fade>
              </Modal>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Todo;
